var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#B04708"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6666 17.3333C16.6666 17.7013 16.3686 18 15.9999 18C15.6313 18 15.3333 17.7013 15.3333 17.3333C15.3333 15.4953 13.8379 14 11.9999 14C10.1619 14 8.66659 15.4953 8.66659 17.3333C8.66659 17.7013 8.36859 18 7.99992 18C7.63125 18 7.33325 17.7013 7.33325 17.3333C7.33325 14.76 9.42725 12.6667 11.9999 12.6667C14.5726 12.6667 16.6666 14.76 16.6666 17.3333M11.9999 7.33333C12.7353 7.33333 13.3333 7.93133 13.3333 8.66667C13.3333 9.402 12.7353 10 11.9999 10C11.2646 10 10.6666 9.402 10.6666 8.66667C10.6666 7.93133 11.2646 7.33333 11.9999 7.33333M11.9999 11.3333C13.4706 11.3333 14.6666 10.1373 14.6666 8.66667C14.6666 7.196 13.4706 6 11.9999 6C10.5293 6 9.33325 7.196 9.33325 8.66667C9.33325 10.1373 10.5293 11.3333 11.9999 11.3333",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoAvatar);
export default __webpack_public_path__ + "static/media/Icono_Avatar.2024ad3aa6d3164deca52b76b8e3e33e.svg";
export { ForwardRef as ReactComponent };